import React from 'react';

export const CodeIcon = () => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id="codeIconT">code icon</title>
            <desc id="codeIconD">A vector illustration of a code icon</desc>
            <path
                d="M17.5 2h-10a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5Z"
                fill="#5F65FB"
            />
            <path
                d="M9.5 14.75a.75.75 0 0 1-.53-.22l-2-2a.75.75 0 0 1 0-1.06l2-2a.75.75 0 1 1 1.06 1.06L8.56 12l1.47 1.47a.75.75 0 0 1-.53 1.28ZM15.5 14.75a.75.75 0 0 1-.53-1.28L16.44 12l-1.47-1.47a.75.75 0 0 1 1.06-1.06l2 2a.748.748 0 0 1 0 1.06l-2 2a.75.75 0 0 1-.53.22Z"
                fill="#FDFCFC"
                opacity=".9"
            />
            <path
                d="M11.5 16.25a.75.75 0 0 1-.721-.956l2-7a.75.75 0 1 1 1.442.412l-2 7a.75.75 0 0 1-.72.544Z"
                fill="#FDFCFC"
                opacity=".5"
            />
        </svg>
    );
};
